import { api } from 'utility';
import { fileDownloader } from 'utility/util';
import jMoment from 'moment-jalaali';
import { enifyDateTime } from 'utility';
import pdfDownloader from '../../Financial/ReportSettlement/components/PdfDownloader';
import {
  getCRUImprestUrl,
  getStatesUrl,
  getCitiesUrl,
  getFinancialAccumulativeReportFunderAndImprestUrl,
  getAccumulativeReportFunderAndImprestUrl,
  getFinancialReportImprestUrl,
  getCreateFunderUrl,
  getExportAllFunderImprestReportUrl,
  getAddressExportFileUrl,
  getGuildServiceUrl,
  getCreditUrl,
  getDeleteOrEditGuildUrl,
  getShebaGuildUrl,
  getPaymentServiceUrl,
  getFinancialTransferUrl,
  getShebaServiceUrl,
  getCardServiceUrl,
  getInvoiceSaleListUrl,
  getToggleAutoSettelmentUrl,
  getRequestSettelmentFromGuildUrl,
  getDetaileSettelmentUrl,
  getFinancialSettelmentWallet,
  getBusinessUrl,
  getReportBillUrl,
  getExportBillReportUrl,
  getBusinessBranchCreditUrl,
  getBranchRequestSettelmentFromWalletUrl,
  getBranchRequestSettelmentFromGuildUrl,
  getCallbackuriListUrl,
  getPayInvoiceByCreditUrl,
  getExportDetaileSettelmentUrl,
  getExportRequestSettelmentUrl,
  getReportSettelmentRequestUrl,
  getPaginateReportSaleInvoiceUrl,
  getReportSaleInvoiceUrl,
  getExportReportSaleInvoiceUrl,
  getExportReportPurchaseInvoiceUrl,
  getReportPurchaseInvoiceUrl,
  getReportAccountNumberUrl,
  getShebaInformationUrl,
  getExportFunderImprestReportUrl,
  getReportImprestListUrl,
  getReportImrestAggregate,
  getImpresDepositReportUrl
} from 'URLs';
class ImprestServices {
  getImprest(params) {
    return api.get(getCRUImprestUrl(), { params }).then((res) => res.data);
  }
  getImprestReport(params) {
    return api.get(getReportImprestListUrl(), { params }).then((res) => res.data);
  }
  getImprestReportAggregate(params) {
    return api.get(getReportImrestAggregate(), { params }).then((res) => res.data);
  }
  getStates() {
    return api.get(getStatesUrl()).then((res) => res.data);
  }
  getCities(params) {
    return api.get(getCitiesUrl(), { params }).then((res) => res.data);
  }
  addImprest(data) {
    return api.post(getCRUImprestUrl(), data);
  }
  updateImprest(data) {
    return api.put(getCRUImprestUrl(), data);
  }
  funderImprest(data, params) {
    return api
      .post(getFinancialAccumulativeReportFunderAndImprestUrl(), data, { params })
      .then((res) => res.data);
  }
  /**
   * لیست کل تنخواه
   */
  getAllFunderImprest(data, params) {
    return api
      .post(getAccumulativeReportFunderAndImprestUrl(), data, { params })
      .then((res) => res.data);
  }
  getReportSummary(data, params) {
    return api.post(getFinancialReportImprestUrl(), data, { params }).then((res) => res.data);
  }
  getFunder(params) {
    return api.get(getCreateFunderUrl(), { params }).then((res) => res.data);
  }
  reportFunderImprest(type, data, params) {
    return api
      .post(getExportAllFunderImprestReportUrl(type), data, { params })
      .then((res) => res.data);
  }
  getAddressExportFile() {
    return api.get(getAddressExportFileUrl()).then((res) => res.data);
  }

  /** @format */

  createAccount(params) {
    return api.post(getGuildServiceUrl(), {
      ...params,
    });
  }

  aliasNameAccount(params, guild) {
    return api.put(getDeleteOrEditGuildUrl(guild), params);
  }

  credit() {
    return api.get(getCreditUrl()).then((res) => res.data);
  }
  creditHasTotalInfo() {
    return api.get(getCreditUrl(), {}).then((res) => res.data);
  }
  charge(params) {
    return api.get(getPaymentServiceUrl(), { params }).then((res) => res.data);
  }

  getShebaAccount(params) {
    return api.get(getShebaGuildUrl(), { params }).then((res) => res.data);
  }

  moneyTransfer(param) {
    return api.post(getFinancialTransferUrl(), {
      ...param,
    });
  }

  reportFactorsDebtor(param, dataParams) {
    return api.post(getPaginateReportSaleInvoiceUrl(param.size, param.page), {
      ...dataParams,
    });
  }

  reportInvoiceDebtor(data, params) {
    return api.post(getReportSaleInvoiceUrl(), data, { params }).then((res) => res.data);
  }
  reportInvoiceDebtorExport(data, params, exportType, onError) {
    return fileDownloader(
      'POST',
      getExportReportSaleInvoiceUrl(exportType),
      params,
      data,
      null,
      exportType,
      null,
      onError,
    );
  }

  eportFactorsDetailsDebtor(params) {
    return api.get(getInvoiceSaleListUrl(), { params }).then((res) => res.data);
  }

  reportFactorsDetailsDebtorSecondary(invoiceId) {
    const params = {
      page: 0,
      size: 10,
    };
    const data = {
      filterVOS: [
        {
          id: '1349',
          key: 'invoiceId',
          value: invoiceId,
        },
      ],
      orderByElementVOS: [],
      parentParams: [
        {
          key: 'START_DATE',
          value: enifyDateTime(
            jMoment(new Date().setHours(0, 0, 0, 0))
              .subtract(365, 'days')
              ?.format('jYYYY/jMM/jDD HH:mm:ss'),
          ),
        },
        {
          key: 'END_DATE',
          value: enifyDateTime(jMoment(new Date())?.format('jYYYY/jMM/jDD HH:mm:ss')),
        },
      ],
    };
    return api.post(getReportSaleInvoiceUrl(), data, { params }).then((res) => res.data);
  }

  reportFactorsDetails(param, dataParams) {
    return api.post(getPaginateReportSaleInvoiceUrl(param.size, param.page), {
      ...dataParams,
    });
  }

  reportFactorsCreditor(data, params) {
    return api.post(getReportPurchaseInvoiceUrl(), data, { params }).then((res) => res.data);
  }

  reportFactorsCreditorExport(dataParams, params, type, onError) {
    return fileDownloader(
      'POST',
      getExportReportPurchaseInvoiceUrl(type),
      params,
      dataParams,
      null,
      type,
      null,
      onError,
    );
  }

  getSheba(params) {
    return api.get(getShebaServiceUrl(), { params }).then((res) => res.data);
  }

  deleteGuild(code) {
    return api.delete(getDeleteOrEditGuildUrl(code), {}).then((res) => res.data);
  }
  getGuild() {
    return api.get(getGuildServiceUrl()).then((res) => res.data);
  }

  getCard(params) {
    return api.get(getCardServiceUrl(), { params }).then((res) => {
      return res.data.result.filter((item) => {
        return item?.number;
      });
    });
  }

  autoSettlement(param) {
    return api.post(getToggleAutoSettelmentUrl(), {
      ...param,
    });
  }

  deleteSettlement(param) {
    return api.delete(getToggleAutoSettelmentUrl(), { params: { ...param } });
  }

  deleteSettlementById(id) {
    return api.delete(getDetaileSettelmentUrl(id), {});
  }

  withdrawal(param) {
    return api.post(getRequestSettelmentFromGuildUrl(), {
      ...param,
    });
  }

  withdrawalWallet(param) {
    return api.post(getFinancialSettelmentWallet(), {
      ...param,
    });
  }

  getBusiness() {
    return api.get(getBusinessUrl());
  }

  reportTransaction(data, params) {
    return api.post(getReportBillUrl(), data, { params }).then((res) => res.data);
  }

  reportTransactionExport(data, params, exportType, onError) {
    return fileDownloader(
      'POST',
      getExportBillReportUrl(exportType),
      params,
      data,
      null,
      exportType,
      null,
      onError,
    );
  }

  reportAccountNumber() {
    return api.get(getReportAccountNumberUrl()).then((res) => res.data);
  }

  reportSettlementApi(data, params) {
    return api.post(getReportSettelmentRequestUrl(), data, { params }).then((res) => res.data);
  }

  reportSettlementApiExport(data, params, exportType, onError) {
    return fileDownloader(
      'POST',
      getExportRequestSettelmentUrl(exportType),
      params,
      data,
      null,
      exportType,
      null,
      onError,
    );
  }

  reportSettlementStatusApi(id) {
    return api.get(getDetaileSettelmentUrl(id)).then((res) => res.data);
  }

  reportSettlementListApi(params) {
    return api.get(getRequestSettelmentFromGuildUrl(), { params }).then((res) => res.data);
  }

  reportSettlementGetPdf(id) {
    const file_name = `settlement-report-${id}.pdf`;
    return pdfDownloader(getExportDetaileSettelmentUrl(id), file_name);
  }

  getGuildsList(obj) {
    const params = { ...obj };
    return api.get(getGuildServiceUrl(), { params }).then((res) => res.data);
  }

  payInvoiceWithCredit(invoiceId) {
    return api.post(getPayInvoiceByCreditUrl(invoiceId));
  }

  getBusinessCallbackUri(params) {
    return api.get(getCallbackuriListUrl(), { params }).then((res) => res.data);
  }

  getSettlementList(params, url) {
    return api.get(url, { params }).then((res) => res.data);
  }
  SettelmentByToolUser(userId, data) {
    return api.post(getBranchRequestSettelmentFromWalletUrl(userId), data).then((res) => res.data);
  }

  SettelmentByTool(branchId, data) {
    return api.post(getBranchRequestSettelmentFromGuildUrl(branchId), data).then((res) => res.data);
  }
  businessCredit(params, branchId) {
    return api.get(getBusinessBranchCreditUrl(branchId), { params }).then((res) => res.data);
  }
  /**
   * خروجی pdf گزارش کل تنخواه
   * @param {*} param0
   * @returns
   */
  exportPdffunderImprestReport(data, params) {
    const url = getExportFunderImprestReportUrl();
    return api.post(url, data, { params }).then((res) => res.data);
  }

  inquiryPaymentAccountNumber(shebaNumber) {
    return api.get(getShebaInformationUrl(shebaNumber)).then((res) => res.data);
  }

  getDepositReportList(params) {
    return api.get(getImpresDepositReportUrl(), { params }).then((res) => res.data);
  }
}

export default new ImprestServices();
